import React from 'react';
import './GameSelector.css';

interface GameOption {
  id: string;
  name: string;
  description: string;
  icon: string;
  variant: string;
  features: string[];
}

interface GameSelectorProps {
  onGameSelect: (gameId: string) => void;
}

const GameSelector: React.FC<GameSelectorProps> = ({ onGameSelect }) => {
  const games: GameOption[] = [
    {
      id: 'classic-ludo',
      name: 'Classic Ludo',
      description: 'Traditional Ludo with single dice',
      icon: '🎲',
      variant: 'Classic',
      features: [
        'Single dice roll',
        'Roll again on 6',
        'Capture opponents',
        'Safe starting positions',
      ],
    },
    {
      id: 'naija-ludo',
      name: 'Naija Ludo',
      description: 'Nigerian style with two dice and blocking',
      icon: '🎲🎲',
      variant: 'Nigerian',
      features: [
        'Two dice rolls',
        'Combine or separate dice',
        'Blocking with same color',
        'Three 6s ends turn',
        'Roll again on double 6s',
      ],
    },
    {
      id: 'chess',
      name: 'Chess',
      description: 'Classic strategy game (Coming Soon)',
      icon: '♟️',
      variant: 'Strategy',
      features: [
        'Strategic gameplay',
        'Multiple piece types',
        'Checkmate to win',
        'Time controls',
      ],
    },
    {
      id: 'checkers',
      name: 'Checkers',
      description: 'Jump and capture game (Coming Soon)',
      icon: '⚫',
      variant: 'Classic',
      features: [
        'Diagonal movement',
        'Jump to capture',
        'King pieces',
        'Strategic positioning',
      ],
    },
  ];

  const handleGameSelect = (gameId: string) => {
    if (gameId === 'chess' || gameId === 'checkers') {
      alert('Coming soon! This game is under development.');
      return;
    }
    onGameSelect(gameId);
  };

  return (
    <div className="game-selector">
      <div className="game-selector-header">
        <h1>🎮 Koja Classics</h1>
        <p>Choose your game and start playing!</p>
      </div>

      <div className="games-grid">
        {games.map((game) => (
          <div
            key={game.id}
            className={`game-card ${game.id === 'chess' || game.id === 'checkers' ? 'coming-soon' : ''}`}
            onClick={() => handleGameSelect(game.id)}
          >
            <div className="game-icon">{game.icon}</div>
            <div className="game-info">
              <h3 className="game-name">{game.name}</h3>
              <div className="game-variant">{game.variant}</div>
              <p className="game-description">{game.description}</p>

              <div className="game-features">
                <h4>Features:</h4>
                <ul>
                  {game.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              {game.id === 'chess' || game.id === 'checkers' ? (
                <div className="coming-soon-badge">Coming Soon</div>
              ) : (
                <div className="play-button">Play Now</div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="game-selector-footer">
        <p>More games coming soon! 🚀</p>
      </div>
    </div>
  );
};

export default GameSelector;
